import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Lock, Login } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 6, 
            textAlign: 'center',
            borderRadius: 3,
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Lock 
              sx={{ 
                fontSize: 80, 
                color: 'primary.main',
                mb: 2
              }} 
            />
          </Box>
          
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 'bold',
              color: 'text.primary',
              mb: 2
            }}
          >
            Accès Restreint
          </Typography>
          
          <Typography 
            variant="h6" 
            color="text.secondary" 
            sx={{ mb: 4, lineHeight: 1.6 }}
          >
            Vous devez être connecté pour accéder aux freelances et aux missions.
            <br />
            Rejoignez notre communauté sportive dès maintenant !
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              component={Link}
              to="/login"
              state={{ from: location }}
              variant="contained"
              size="large"
              startIcon={<Login />}
              sx={{ 
                px: 4, 
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1.1rem'
              }}
            >
              Se connecter
            </Button>
            
            <Button
              component={Link}
              to="/register"
              variant="outlined"
              size="large"
              sx={{ 
                px: 4, 
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1.1rem'
              }}
            >
              S'inscrire
            </Button>
          </Box>
          
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ mt: 4 }}
          >
            Déjà membre ? Connectez-vous pour découvrir des opportunités sportives près de chez vous.
          </Typography>
        </Paper>
      </Container>
    );
  }

  return children;
};

export default ProtectedRoute;